<template>
  <div>
    <Hero title="Datenschutz" />
    <section class="container content">
      <div class="breadcrumb d-flex">
        <div class="flex-grow-1">
          <nuxt-link :to="localePath('/')">Home</nuxt-link>
          <span class="breadcrumb--separator">></span>
          {{ $t('Datenschutz') }}
        </div>
      </div>

      <h2>{{ $t('Danke, dass du diese Seite besuchst!') }}</h2>

      <datenschutzFr v-if="$i18n.locale == 'fr'" />
      <div v-else>
        Unsere Grundhaltung
        <ul>
          <li>Datensparsamkeit: Wir sammeln so wenig Daten wie möglich.</li>
          <li>
            Datenaustausch: Wenn immer möglich werden die Daten auf unseren
            Server gespeichert.
          </li>
          <li>
            Datensicherheit: Wir geben unser Bestes, damit deine Daten sicher
            sind!
          </li>
        </ul>

        <h2>Allgemeine Hinweise</h2>
        <p>Stand: 1. Mai 2022</p>

        <p>
          Unserer Datenschutzbeauftragter ist erreichbar unter
          <a href="mailto:datenschutz@lernpfad.ch">datenschutz@lernpfad.ch</a>
          .
        </p>

        <p>
          Wir verwenden auf dieser Seite Cookies, ohne die auf lernpfad.ch nicht
          gearbeitet werden kann. Die Cookies behalten für 90 Tage ihre
          Gültigkeit und werden danach durch deinen Browser gelöscht.
        </p>
        <p>
          Wir können auch weitere, nicht notwendige Cookies setzen, bspw. für
          unser eigenes Tracking-Tool oder für externe Inhalte, die in deine
          Lernpfade eingebunden werden können.
        </p>

        <h3>1. Wie werden deine personenbezogenen Daten verarbeitet?</h3>
        Personenbezogene Daten werden nur erhoben, um Verpflichtungen gegenüber
        den Besuchenden nachzukommen. Die Verarbeitung bestimmter
        personenbezogenen Daten ist die Voraussetzung dafür, dass wir dir
        Lernpfade zuordnen können oder du das Passwort zurücksetzen lassen
        kannst.
        <br />
        <br />

        Um die Qualität der Software weiter zu verbessern werden wir unter
        Umständen mit dir in Kontakt treten, damit wir deine Lernpfade im Detail
        anschauen dürfen.

        <h3>2. Informationen, die du uns mitteilst.</h3>
        Daten, die wir direkt von dir erhalten, beispielsweise:

        <ul>
          <li>Zugangsdaten (z. B. Nutzername und Passwort)</li>
          <li>Profildaten (z. B. Name)</li>
          <li>
            Inhaltsdaten (Inhalte der von dir erstellten Lernpfade:
            Texteingaben, Dateien, usw.)
          </li>
        </ul>

        <h4>
          Spendentechnologie
        </h4>
        <p>
          Auf unserer Webseite setzen wir die Spendentechnologie der Firma RaiseNow AG, Hardturmstr. 101, 8005 Zürich ein, deren Datenschutzrichtlinien Sie hier einsehen können: <a href=""https://www.raisenow.com/ch-de/datenschutz>https://www.raisenow.com/ch-de/datenschutz</a>. 
          Die erfassten personen- und zahlungsbezogenen Daten sowie Kommunikations-Präferenzen werden von RaiseNow auf Grundlage unserer Interessen gem. Art. 6 Abs. 1 lit. b DSGVO und eines Auftragsverarbeitungsvertrages 
          gem. Art. 28 Abs. 3 S. 1 DSGVO erfasst. RaiseNow AG mit Sitz in der Schweiz und RaiseNow GmbH mit Sitz in Deutschland erfüllen alle Vorgaben der Europäischen Datenschutzgrundverordnung. Die Schweiz gilt als sicheres Drittland, 
          dem die Europäische Kommission per Angemenssenheitsbeschluss ein angemessenes Datenschutzniveau bestätigt hat. Dazu gehört beispielsweise die Sicherheit der Datenverarbeitung, die bei der RaiseNow AG regelmässig durch den TÜV SÜD auf Grundlage des PCI-DSS SAQ D Level 2 Sicherheitsstandards geprüft und zertifiziert wird (<a href="https://developer.raisenow.com/docs/pci-dss/Certificate-of-Validation_en.pdf">https://developer.raisenow.com/docs/pci-dss/Certificate-of-Validation_en.pdf</a>). RaiseNow kann die erfassten Daten in anonymisierter Form, also ohne Zuordnung zu einem Spender, zur Optimierung oder Verbesserung der eigenen Services nutzen, jedoch nicht, um diese direkt zu kontaktieren oder Daten an Dritte weiterzugeben.

          </p>

        <h3>
          3. Informationen, die aufgrund deiner Nutzung automatisch gesammelt
          werden
        </h3>
        Während du die Internetseite besuchst, werden automatisch Daten von dir
        mittels Tracking gesammelt. Dazu setzen wir folgende Tools ein:

        <h4>Tracking: Amplitude</h4>

        Folgende Daten werden auf einem Server von Amplitude gespeichert:
        <ul>
          <li>pseudonymisierte IP-Adresse, Datum und Uhrzeit,</li>
          <li>allgemeine Informationen zum Betriebssystem resp. Browser.</li>
        </ul>

        <p>
          Diese Nutzungsdaten bilden die Basis für statistische Auswertungen,
          sodass Trends erkennbar sind, anhand derer wir Lernpfad.ch
          entsprechend verbessern können.
        </p>

      

        <h3>
          4. Informationen, die wir an Auftragsdatenbearbeiter weitergeben
        </h3>

        <p>
          Wir können Subunternehmer (sog. Auftragsdatenbearbeiter) zur
          Bearbeitung deiner Daten hinzuziehen, damit sie uns bspw. die nötige
          Informatik-Infrastruktur bereitstellen oder diese betreiben. Wir
          wählen sie sorgfältig aus und prüfen, ob deine Daten angemessen gegen
          Datenschutzverletzungen gesichert werden.
        </p>
        <p>
          Wenn es sich um Unternehmen handelt, die ihren Hauptsitz in
          Drittstaaten haben (bspw. den Vereinigten Staaten von Amerika), werden
          wir geeignete Massnahmen ergreifen, damit deine Daten nicht an
          Strafbehörden oder Sicherheitsdienste dieses Staates herausgegeben
          werden.
        </p>
        <p>Konkret beauftragen wir zurzeit die folgenden Unternehmen:</p>

        <h4>Hosting: Amazon / Heroku</h4>
        Die Speicherung der Nutzungsdaten erfolgt auf Servern von Amazon und
        <a
          target="_blank"
          href="https://devcenter.heroku.com/articles/gdpr"
        >
          Heroku
        </a>
        in Irland. Beide Unternehmen haben ihren Hauptsitzu in den Vereinigten
        Staaten von Amerika.

        <h4>DNS und Cache: Cloudflare</h4>
        Für die Namensauflösung (DNS) und das schnelle Ausliefern von statischen
        Dateien wie Javascript (.js) und Stylesheets (.css), verwenden wir den
        Dienst von Cloudflare. Für diesen Teil gelten die Datenschutzbetimmungen
        von
        <a
          target="_blank"
          href="https://www.cloudflare.com/de-de/privacypolicy/"
        >
          Cloudflare
        </a>
        .

        <h4>Tracking: Amplitude</h4>
        Um Lernpfad.ch ständig verbessern zu können erstellen wir statistische
        Auswertungen. Die Daten dazu werden von von uns mittels
        <a
          target="_blank"
          href="https://amplitude.com/privacy"
        >
          Amplitude
        </a>
        erhoben und gespeichert.

        <h3>
          5. Drittinhalte, die wir oder die Nutzenden auf Lernpfad.ch einbinden
        </h3>
        Wir können auf lernpfad.ch Drittinhalte einbinden. Das gilt auch für die
        Autor:innen eines Lernpfads.

      
        Zu diesem Zweck setzen wir den Dienst iframely ein. Für diesen Teil
        gelten die <a href"https://iframely.com/privacy">Datenschutzbestimmungen</a> von
        <a
          target="_blank"
          href="https://iframely.com/docs/gdpr"
        >
          iframely
        </a>

      
        , einem Unternehmen aus Kanada. Für alle
        von Lernpfad-Autor:innen eingesetzte Dienste gelten die jeweiligen
        Datenschutzbestimmungen.

        <h3>
          6. Informationen, die wir über dich aus anderen Quellen erhalten.
        </h3>
        Wir verarbeiten keine Informationen aus anderen Quellen.

        <h3>7. Welche Rechte hast du?</h3>
        Diese Rechte kannst du geltend machen:

        <ul>
          <li>
            Widerspruchsrecht: Du kannst uns jederzeit mitteilen, wenn du mit
            einer Bearbeitung nicht einverstanden bist. Falls wir zum Schluss
            kommen, dass wir keinen berechtigten Grund zur Bearbeitung haben,
            werden wir die Bearbeitung einstellen.
          </li>
          <li>
            Recht auf Auskunft: Du kannst bei uns jederzeit Auskunft darüber
            verlangen, welche Daten wir von dir bearbeiten. Wir werden dir alle
            uns zur Verfügung stehenden Auskünfte erteilen, ausser wenn dies
            unsere Geschäftsgeheimnisse oder den Datenschutz von anderen Nutzern
            verletzt.
          </li>
          <li>
            Recht auf Löschung: Du kannst bei uns jederzeit eine Löschung deiner
            Daten beantragen («Recht auf Vergessenwerden»). Wir dürfen die
            Löschung solange aufschieben, bis wir keinen berechtigten Grund mehr
            zur Aufbewahrung haben.
          </li>
          <li>
            Recht auf Berichtigung: Bemerkst du, dass deine Daten unvollständig
            oder unrichtig sind, darfst du jederzeit die Korrektur deiner Daten
            verlangen. Wir können dein Gesuch ablehnen oder aufschieben, wenn
            wir deine «falschen» Daten aus einem wichtigen Grund benötigen.
          </li>
          <li>
            Widerruf deiner Einwilligung: Eine Einwilligung, die du uns im
            Zusammenhang mit einer Datenbearbeitung gegeben hast, darfst du
            jederzeit widerrufen.
          </li>
          <li>
            Beschwerde: Du darfst jederzeit beim Eidgenössischen Datenschutz-
            und Öffentlichkeitsbeauftragten eine Meldung machen, wenn du der
            Meinung bist, dass wir gegen das Datenschutzgesetz verstossen.
          </li>
        </ul>

        <p>
          Wir bitten dich um Verständnis dafür, dass wir deine Gesuche nur
          prüfen können, wenn wir deine Identität überprüfen konnten. Deshalb
          kann es sein, dass wir eine Ausweiskopie von dir verlangen, die wir
          nach der Identitätsprüfung selbstverständlich vernichten.
        </p>

        <p>
          Bitte sende dein Gesuch an unseren Datenschutzbeauftragten:
          <br />
          <a href="mailto:datenschutz@lernpfad.ch">datenschutz@lernpfad.ch</a>
          oder melde dich über die Telefonnummer
          <a href="tel:+41313124483">+41 (0) 31 312 44 83</a>
          .
        </p>

        <p>
          Hinweis: Wir können diese Datenschutzerklärung jederzeit ändern, du
          wirst nicht gesondert informiert.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import Hero from '../components/ui/Hero'
import { ampli } from '../mixins/Amplitude/index.js'
import datenschutzFr from '../components/locales/datenschutz_fr.vue'

export default {
  nuxtI18n: {
    paths: {
      fr: '/confidentialite',
    },
  },

  components: {
    Hero,
    datenschutzFr,
  },

  mixins: [ampli],

  scrollToTop: true,

  head() {
    return {
      title: this.$i18n.t('Datenschutzerklärung | Lernpfad'),
    }
  },

  created() {
    ampli.dataProtectionPageViewed()
  },
}
</script>

<style
  scoped
  lang="scss"
>
@import '../assets/style/vars';
@import '../assets/style/utils';

.content,
::v-deep .content {
  max-width: $text-content-max-width;

  p {
    margin-bottom: 1rem;
  }

  h2 {
    margin: 2rem 0 1rem 0;
    @include fontSizeLineHeight(35px, 66px);
  }

  h3 {
    margin: 2rem 0 1rem 0;
    @include fontSizeLineHeight(28px, 36px);
  }

  h4 {
    font-weight: 600;
    margin: 2rem 0 1rem 0;
    @include fontSizeLineHeight(20px, 30px);
  }

  ul {
    margin: 1rem;
  }
}
</style>
